module.exports = __webpack_public_path__ + "static/land_screens-35e8d183bf2b9b50ecc0333cee4dd384.png";